import estyled from '@signal/theme/emotion'
import { getColorBackgroundSelector } from '@signal/theme/selectors'

export const PageWrapper = estyled.div`
  background: ${getColorBackgroundSelector()};
`

export const ChildWrapper = estyled.div<{ headerFooterHeight: number }>`
  height: calc(100vh - ${({ headerFooterHeight }) => headerFooterHeight}px);
`

export const ContentRow = estyled.div`
  display: flex;
  height: 100%;
`

export const LeftWrapper = estyled.div`
  display: flex;
  flex: 0 0 auto;
`

export const MainWrapper = estyled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
`

export const MinWidthWrapper = estyled.div<{
  appMinWidth?: number
  children?: React.ReactNode
}>`
  height: 100%;
  ${({ appMinWidth }) => (appMinWidth ? `min-width: ${appMinWidth}px;` : '')}
`

export const ScrollWrapper = estyled.div<{
  appMinWidth?: number
  hideChrome?: boolean
  hideFooter?: boolean
  children?: React.ReactNode
}>`
  height: 100%;
  ${({ appMinWidth }) =>
    /* also hide the y-overflow to prevent a small y-scrollbar to encompass where the x-scrollbar was rendered */
    appMinWidth ? 'overflow-x: auto; overflow-y: hidden;' : ''}
`
